import { useDispatch } from 'react-redux'
import { setCredentials } from 'src/redux/Slices/authSlice'
import { setParams } from 'src/redux/Slices/configSlice'
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router'

const CheckingData = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  useEffect(() => {
    const cookies = document.cookie.split(';').reduce(
      (acc, cookie) => {
        const [name, value] = cookie.split('=').map((c) => c.trim())
        acc[name] = value
        return acc
      },
      {} as Record<string, string>
    )

    if (cookies.userData) {
      try {
        const parsedUserData = JSON.parse(decodeURIComponent(cookies.userData))
        dispatch(setCredentials(parsedUserData))

        // Удаление куки userData
        document.cookie = 'userData=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
      } catch (error) {
        console.error('Failed to parse userData from cookie:', error)
      }
    }

    const query = new URLSearchParams(location.search)
    const error = query.get('error')
    // const google = query.get('google')

    if (error === 'google') {
      dispatch(setParams({ status: 'error', message: 'Email is incorect' }))
      navigate('/login')
    }
  }, [dispatch])
  return <></>
}

export default CheckingData
